import type { FeatureFlagValues } from '@seen/core/featureFlags'
import type { JSX, ReactNode } from 'react'
import { FeatureFlagContext } from '#src/contexts/feature-flags/FeatureFlagContext.tsx'

export function FeatureFlagProvider({
  values,
  children,
}: {
  values: FeatureFlagValues
  children: ReactNode
}): JSX.Element {
  return (
    <FeatureFlagContext.Provider value={values}>
      {children}
    </FeatureFlagContext.Provider>
  )
}
